module.exports = __webpack_public_path__ + "img/choose-up-cresa.960cfa9c.png";